import { Grid, Typography } from 'src/components/mui';
//@ts-ignore
import React from 'react';
import { useMemo } from 'react';
import { getItems } from './config';

type Props = {
  translation?: any;
};

export default function MoreHelp({ translation }: Props) {
  const items = useMemo(() => getItems(translation), [translation]);

  return (
    <Grid container spacing={4} justifyContent="center">
      {items.map((i, index) => (
        <Grid key={index} item xs={12} sm={6} md={4} lg={3} textAlign="center">
          <Typography variant="h6">{i.title}</Typography>
          <i style={{ fontSize: '40px', margin: '20px 0' }} className={`${i.icon} fa-fw`} />
          <Typography>{i.description}</Typography>
        </Grid>
      ))}
    </Grid>
  );
}
